import React from "react";
import useGetTranslations from "../../../../../dealers/assets/js/dealers_map/hooks/useGetTranslations";

export default function CardEmpty({ error }) {
    const [translations] = useGetTranslations(
        // locale,
        "/api/vehicles/get_translations/"
    );
    return (
        <div className="comparator-card-empty">
            <img src="/static/vehicles/images/card-empty.png" alt="" />

            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_870_49077)">
                    <path
                        d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM11 17H13V13H17V11H13V7H11V11H7V13H11V17Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_870_49077">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>

            {error ? (
                <p className="--text-s --error">{translations.text12}</p>
            ) : (
                <p className="--text-s">{translations.text13}</p>
            )}
        </div>
    );
}
